// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"185":"0a504873","541":"174adf13"}[chunkId] + ".chunk.css";
};